import React, { useRef, useState } from "react";
import { findDragDropFile } from "../../../../utils/useDragFile";
import "./DropFileArea.css";

interface IDropFileAreaProps extends React.HTMLAttributes<HTMLDivElement>{
    dragFile: DataTransferItem;
    onDropFile: (item: File)=>void;
}

export const DropFileArea = ({onDropFile, dragFile, className, children}: IDropFileAreaProps)=>{
    const [formDrag, setFormDrag] = useState(false);
    
    const handleFormDragOver = (e: React.DragEvent)=>{
        e.preventDefault();
        if (dragFile){
            setFormDrag(true);
        }
    }

    const handleFormDragLeave = (e: React.DragEvent)=>{
        e.preventDefault();
        setFormDrag(false);
    }

    const handleFormDrop = (e:React.DragEvent)=>{
        e.preventDefault(); 
        setFormDrag(false);
        const foundFile = findDragDropFile(e.dataTransfer.items)
        if (foundFile){
            const file = foundFile.getAsFile();
            onDropFile(file);
        } else {
            console.log('dropped not supported item')
        }
    }

    return <div
        className={`DropFileArea ${className ? className : ''}`}
        onDragOver={handleFormDragOver}
        onDragLeave={handleFormDragLeave}
        onDrop={handleFormDrop}
    >
        {children}
        {dragFile && !formDrag && <div className="avatarEditor_overlay avatarEditor_overlay_drag">drag here</div>}
        {formDrag && <div className="avatarEditor_overlay avatarEditor_overlay_drop">drop file</div>}
    </div>
}
